import { forwardRef } from 'react'

const DIGIT_MAP = {
  '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
  '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
  '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
  '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
}

const ARABIC_DIGITS_RE = /[٠-٩۰-۹]/g

export function normalizeDigits(value) {
  if (value == null || value === '') return value
  return String(value).replace(ARABIC_DIGITS_RE, (d) => DIGIT_MAP[d] || d)
}

const NumberInput = forwardRef(function NumberInput(
  { onChange, inputMode = 'decimal', type: _ignoredType, ...props },
  ref,
) {
  const handleChange = (e) => {
    const next = normalizeDigits(e.target.value)
    if (next !== e.target.value) e.target.value = next
    onChange?.(e)
  }
  return (
    <input
      ref={ref}
      onChange={handleChange}
      {...props}
      type="text"
      inputMode={inputMode}
    />
  )
})

export default NumberInput
